export const GetTripType = (flightHistory: any) => {
  if (!flightHistory || !Array?.isArray(flightHistory) || flightHistory?.length === 0) {
    return 2;
  }

  const allFlights = flightHistory?.flatMap((entry: any) => entry?.flights).filter(Boolean);

  if (!allFlights || allFlights?.length === 0) {
    return 2;
  }

  const totalFlights = allFlights?.length;

  if (totalFlights === 1) return 1; // One-way

  if (totalFlights === 2) {
    const [firstFlight, secondFlight] = allFlights;
    if (
      firstFlight.departure_city_name === secondFlight?.arrival_city_name &&
      firstFlight.arrival_city_name === secondFlight?.departure_city_name
    ) {
      return 2; // Round-trip
    }
  }

  // If there are more than two flights, it’s definitely multi-city
  if (totalFlights > 2) return 3; // Multi-city

  return 3; // Default to multi-city
};
